import { ReferenceData } from './reference-data.model';

export class UnavailabilityType extends ReferenceData {

  endDate: boolean;
  time: boolean;
  allowOpenEnded: boolean;

  // tslint:disable-next-line:no-any
  constructor(data: any) {
    super(data);
    this.endDate = data.endDate;
    this.time = data.time;
    this.allowOpenEnded = data.allowOpenEnded;
  }
}
